<div class="form-group container-fluid pl-5" *ngIf = "form!=undefined">
    <label class="container-fluid pl-5 ui-checkbox input-label">
        <input class="form-control" name="active" type="checkbox" value="{{form.active}}" (change)="activateForm()"
            [(ngModel)]="form.active">
        <span *ngIf="form.active">form is active</span>
        <span *ngIf="!form.active">form is not active</span>
    </label>
</div>